import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=6d7fabe3"
import script from "./DocumentsNew.vue?vue&type=script&lang=js"
export * from "./DocumentsNew.vue?vue&type=script&lang=js"
import style0 from "./DocumentsNew.vue?vue&type=style&index=0&id=6d7fabe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports